<div mat-dialog-content>
    {{data.message}}
</div>
<div fxLayout='row' fxLayoutAlign='center center' mat-dialog-actions>
    <button class="btn btn-primary" [mat-dialog-close]='true'>Ok</button>
</div>